import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7332da6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { class: "user-wrapper" }
const _hoisted_4 = { class: "info-wrapper" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Eingeladen", -1))
const _hoisted_6 = { class: "info-wrapper" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Zuletzt aktualisiert", -1))
const _hoisted_8 = { class: "delete-button-wrapper" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Benutzer entfernen")
const _hoisted_10 = { class: "tables-wrapper" }
const _hoisted_11 = { class: "table-header" }
const _hoisted_12 = { class: "title-button-wrapper" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Gruppen", -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Zu Gruppe hinzufügen")
const _hoisted_15 = { class: "table-header" }
const _hoisted_16 = { class: "title-button-wrapper" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Berechtigungen", -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Berechtigungen verwalten")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_tabs = _resolveComponent("md-tabs")!
  const _component_md_avatar = _resolveComponent("md-avatar")!
  const _component_user_card_loader = _resolveComponent("user-card-loader")!
  const _component_md_button = _resolveComponent("md-button")!
  const _component_md_card = _resolveComponent("md-card")!
  const _component_md_table_column = _resolveComponent("md-table-column")!
  const _component_md_table = _resolveComponent("md-table")!
  const _component_empty_hint = _resolveComponent("empty-hint")!
  const _component_user_delete_modal = _resolveComponent("user-delete-modal")!
  const _component_user_add_group_modal = _resolveComponent("user-add-group-modal")!
  const _component_user_remove_from_group_modal = _resolveComponent("user-remove-from-group-modal")!
  const _component_update_permissions_modal = _resolveComponent("update-permissions-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_md_tabs, {
      title: "Benutzer",
      "title-only": ""
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_md_card, {
          variant: "filled",
          class: "user-card"
        }, {
          default: _withCtx(() => [
            (_ctx.user)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_md_avatar, {
                    variant: "image",
                    size: "large",
                    content: _ctx.user.image
                  }, null, 8, ["content"]),
                  _createElementVNode("h2", null, _toDisplayString(_ctx.user.name), 1),
                  _createElementVNode("h4", null, _toDisplayString(_ctx.user.email), 1),
                  _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("p", null, _toDisplayString(_ctx.formatedDateTime(new Date(_ctx.user.created))) + " Uhr", 1)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("p", null, _toDisplayString(_ctx.formatedDateTime(new Date(_ctx.user.updated))) + " Uhr", 1)
                  ])
                ], 64))
              : (_openBlock(), _createBlock(_component_user_card_loader, { key: 1 })),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_md_button, {
                variant: "filled",
                mode: "delete",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteModal.open()))
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_md_button, {
                variant: "outlined",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addGroupModal.open()))
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              })
            ])
          ]),
          ((_ctx.groups && _ctx.groups.length > 0) || _ctx.isGroupsLoading)
            ? (_openBlock(), _createBlock(_component_md_table, {
                key: 0,
                rows: _ctx.groups,
                header: false,
                "skeleton-rows": 3,
                clickable: "",
                onClick: _ctx.redirectToGroup,
                onButtonClick: _ctx.handleGroupsTableClick
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_md_table_column, {
                    title: "Name",
                    display: "name"
                  }),
                  _createVNode(_component_md_table_column, {
                    title: "",
                    display: "remove",
                    type: "button"
                  })
                ]),
                _: 1
              }, 8, ["rows", "onClick", "onButtonClick"]))
            : (_openBlock(), _createBlock(_component_empty_hint, {
                key: 1,
                title: "Dieser Benutzer ist in keiner Gruppe",
                variant: "inline"
              })),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode(_component_md_button, {
                variant: "outlined",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updatePermissionsModal.open()))
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              })
            ])
          ]),
          ((_ctx.permissions && _ctx.permissions.length > 0) || !_ctx.user)
            ? (_openBlock(), _createBlock(_component_md_table, {
                key: 2,
                rows: _ctx.permissions,
                header: false,
                "skeleton-rows": 3
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_md_table_column, {
                    title: "Readable",
                    display: "readable"
                  })
                ]),
                _: 1
              }, 8, ["rows"]))
            : (_openBlock(), _createBlock(_component_empty_hint, {
                key: 3,
                title: "Diesem Benutzer wurden keine Berechtigungen zugewiesen",
                variant: "inline"
              }))
        ])
      ])
    ]),
    _createVNode(_component_user_delete_modal, {
      ref: "deleteModal",
      user: _ctx.user || undefined,
      onSubmit: _ctx.deleteUser,
      loading: _ctx.isDeleteModalLoading
    }, null, 8, ["user", "onSubmit", "loading"]),
    _createVNode(_component_user_add_group_modal, {
      ref: "addGroupModal",
      onSubmit: _ctx.updateGroupsAndPermissions,
      user: _ctx.user
    }, null, 8, ["onSubmit", "user"]),
    _createVNode(_component_user_remove_from_group_modal, {
      ref: "removeFromGroupModal",
      onSubmit: _ctx.updateGroupsAndPermissions,
      user: _ctx.user,
      group: _ctx.targetGroup
    }, null, 8, ["onSubmit", "user", "group"]),
    _createVNode(_component_update_permissions_modal, {
      ref: "updatePermissionsModal",
      permissions: _ctx.userPermissions,
      onSubmit: _ctx.setPermissions
    }, null, 8, ["permissions", "onSubmit"])
  ]))
}